import { GebaeudeTyp, HOTWATER_OPTIONS, MASSNAHMEN_DACH_OPTIONS_CURRENT, MASSNAHMEN_DACH_OPTIONS_NEW, MASSNAHMEN_DACH_OPTIONS_NEW_DECKE, MASSNAHMEN_DACH_OPTIONS_NEW_SPARREN, MASSNAHMEN_FASSADE_OPTIONS_CURRENT, MASSNAHMEN_FASSADE_OPTIONS_NEW, MASSNAHMEN_FENSTER_OPTIONS_CURRENT, MASSNAHMEN_FENSTER_OPTIONS_NEW, MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT, MASSNAHMEN_HEIZUNG_OPTIONS_NEW, MASSNAHMEN_KELLER_OPTIONS_CURRENT, MASSNAHMEN_KELLER_OPTIONS_NEW, MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT, MASSNAHMEN_LUEFTUNG_OPTIONS_NEW, MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT, MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW, MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT, MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW, ROOF_ORIENTATIONS, VERBRAUCHS_EINHEITEN, VERBRAUCHS_EINHEITEN_GAS, VERBRAUCHS_EINHEITEN_HOLZ, VERBRAUCHS_EINHEITEN_OEL } from "./types.ts";

export interface MainPropertiesDeclare{
  key: MainPropertyKey;
  label: string; 
  type: "boolean" | "number" | "plz" | "year" | "year_based" | "string" | "options" | "gebaeude_typ" | "heated_segments"; 
  step?: number;
  placeholder?: string | number;
  hint?: string;
  unit?: string;
  options?: Array<{label: string, value: string | number}>
  default: MainPropertyValue;
}

export const MAIN_PROPERTIES : Array<MainPropertiesDeclare> = [
    {key: "gebaeude_typ", label: "Gebäude Typ", type: "gebaeude_typ", default: "sfh" as GebaeudeTyp},
    {key: "postleitzahl", label: "Postleitzahl", type: "plz", placeholder:10557, default: undefined},
    {key: "strasse", label: "Straße", type: "string", placeholder:"Musterstraße", default: undefined},
    {key: "hausnummer", label: "Hausnummer", type: "number", placeholder:42, default: undefined},

    {key: "vollgeschosse", label: "Vollgeschosse", type: "number", placeholder:3, step: 1, default: undefined},
    {key: "wohneinheiten", label: "Wohneinheiten", type: "number", step: 1, placeholder: "2", default: undefined},
    {key: "baujahr", label: "Baujahr", type: "year", placeholder:"1987", default: undefined},
    {key: "baujahr_base", label: "Baujahr", type: "year_based", placeholder:"1987", default: undefined},
    {key: "wohnflaeche", label: "Wohnfläche m²", type: "number", placeholder:"120 m²", step: 1,unit:"m²", default: undefined},
    {key: "privat", label: "Selbstnutzender Eigentümer<br>(angemeldeter Erstwohnsitz)", type: "boolean", default: true},

    {key: "verbrauchseinheit_oel", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN_OEL, default: VERBRAUCHS_EINHEITEN_OEL[0].value},
    {key: "verbrauchseinheit_gas", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN_GAS, default: VERBRAUCHS_EINHEITEN_GAS[0].value},
    {key: "verbrauchseinheit_holz", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN_HOLZ, default: VERBRAUCHS_EINHEITEN_HOLZ[0].value},
    {key: "verbrauchseinheit_andere", label: "Einheit", type: "options", options: VERBRAUCHS_EINHEITEN, default: VERBRAUCHS_EINHEITEN[0].value},

    {key: "oelverbrauch", label: "Ölverbrauch", type: "number", step: 500, unit:"l/Jahr", placeholder:"120 l/Jahr", default: undefined},
    {key: "gasverbrauch", label: "Gasverbrauch", type: "number", step: 500,unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},
    {key: "gasverbrauch_m3", label: "Gasverbrauch", type: "number", step: 500,unit:"m³/Jahr", placeholder:"1200 m³/Jahr", default: undefined},
    {key: "holzverbrauch", label: "Verbrauch von Pettets / Holz", type: "number", step: 500,unit:"kg/Jahr", placeholder:"1200 kg/Jahr", default: undefined},
    {key: "holzverbrauch_m3", label: "Verbrauch von Pettets / Holz", type: "number", step: 500,unit:"m³/Jahr", placeholder:"1200 m³/Jahr", default: undefined},
    {key: "holzverbrauch_t", label: "Verbrauch von Pettets / Holz", type: "number", step: 500,unit:"t/Jahr", placeholder:"1200 t/Jahr", default: undefined},
    {key: "stromverbrauchdiodenheizung", label: "Stromverbrauch", type: "number", step: 500,unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},

    
    {key: "stromverbrauchwaermepumpe", label: "Verbrauch Wärmepumpe", type: "number", step: 500,unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},

    {key: "stromverbrauch", label: "Stromverbrauch", type: "number", step: 500, unit:"kwh/Jahr", placeholder:"1200 kwh/Jahr", default: undefined},
    {key: "budget", label: "Budget", type: "number", step: 500,unit:"€", placeholder:"1200 €", default: undefined},
    {key: "massnamen_empfehlen", label: "Maßnamen empfehlen", type: "boolean", default: undefined},
    {key: "beheizte_segmente", label: "Beheizte Bereiche", hint: "Werte durch klicken und ziehen oder eintippen einstellen.", type: "heated_segments", default: [0,100,0]},
    {key: "darlehen", label: "Darlehenskosten pauschal", type: "number", step: 500, unit:"€", placeholder:"150000 €", default: undefined},
    {key: "kostensteigerung_energie", label: "Kostensteigerung Energie", type: "number", unit:"%", placeholder:"3 %", step:0.1, default: undefined},
    {key: "co2_price", label: "CO₂ Preis", type: "number", unit:"€/t", placeholder:"55 €", step:5, default: 55},

//     {
//     "description": "Heizsysteme",
//     "isfp": false,
//     "options": {
//         "current_state": [
//             {
//                 "code": "heating_system_current_0",
//                 "system": "Öl-Konstanttemperaturkessel",
//                 "efficiency": 0.53,
//                 "label": "Öl-Konstanttemperaturkessel"
//             },
//             {
//                 "code": "heating_system_current_1",
//                 "system": "Gas-Konstanttemperaturkessel",
//                 "efficiency": 0.55,
//                 "label": "Gas-Konstanttemperaturkessel"
//             },
//             {
//                 "code": "heating_system_current_10",
//                 "system": "Öl-Brennwert",
//                 "efficiency": 0.78,
//                 "label": "Öl-Brennwert"
//             },
//             {
//                 "code": "heating_system_current_2",
//                 "system": "Holz- / Pelletkessel",
//                 "efficiency": 0.8,
//                 "label": "Holz- / Pelletkessel"
//             },
//             {
//                 "code": "heating_system_current_3",
//                 "system": "Luft-Wasser Wärmepumpe",
//                 "efficiency": 0.68,
//                 "label": "Luft-Wasser Wärmepumpe"
//             },
//             {
//                 "code": "heating_system_current_4",
//                 "system": "Sole-Wasser Wärmepumpe",
//                 "efficiency": 0.72,
//                 "label": "Sole-Wasser Wärmepumpe"
//             },
//             {
//                 "code": "heating_system_current_5",
//                 "system": "Elektrodirektheizung",
//                 "efficiency": 0.8,
//                 "label": "Elektrodirektheizung"
//             },
//             {
//                 "code": "heating_system_current_6",
//                 "system": "Fernwärme",
//                 "efficiency": 1,
//                 "label": "Fernwärme"
//             },
//             {
//                 "code": "heating_system_current_7",
//                 "system": "Gas-Niedertemperaturkessel",
//                 "efficiency": 0.63,
//                 "label": "Gas-Niedertemperaturkessel"
//             },
//             {
//                 "code": "heating_system_current_8",
//                 "system": "Öl-Niedertemperaturkessel",
//                 "efficiency": 0.6,
//                 "label": "Öl-Niedertemperaturkessel"
//             },
//             {
//                 "code": "heating_system_current_9",
//                 "system": "Gas-Brennwert",
//                 "efficiency": 0.8,
//                 "label": "Gas-Brennwert"
//             }
//         ],
//         "planned_state": [
//             {
//                 "code": "heating_system_planned_0",
//                 "system": "nicht sanieren",
//                 "efficiency": 0.53,
//                 "label": "nicht sanieren"
//             },
//             {
//                 "code": "heating_system_planned_1",
//                 "system": "Sole-Wasser Wärmepumpe",
//                 "efficiency": 0.7,
//                 "label": "Sole-Wasser Wärmepumpe"
//             },
//             {
//                 "code": "heating_system_planned_2",
//                 "system": "Luft-Wasser Wärmepumpe",
//                 "efficiency": 0.68,
//                 "label": "Luft-Wasser Wärmepumpe"
//             },
//             {
//                 "code": "heating_system_planned_3",
//                 "system": "Luft-Wärmepumpe / Gas-Brennwert",
//                 "efficiency": 0.66,
//                 "label": "Luft-Wärmepumpe / Gas-Brennwert"
//             },
//             {
//                 "code": "heating_system_planned_4",
//                 "system": "Luft-Wärmepumpe / Öl-Brennwert",
//                 "efficiency": 0.65,
//                 "label": "Luft-Wärmepumpe / Öl-Brennwert"
//             },
//             {
//                 "code": "heating_system_planned_5",
//                 "system": "Fernwärme",
//                 "efficiency": 1,
//                 "label": "Anschluss Fernwärme"
//             },
//             {
//                 "code": "heating_system_planned_6",
//                 "system": "Brennstoffzellenheizung",
//                 "efficiency": 1.2,
//                 "label": "Brennstoffzellenheizung"
//             },
//             {
//                 "code": "heating_system_planned_7",
//                 "system": "Holz- / Pelletkessel",
//                 "efficiency": 1,
//                 "label": "Holz- / Pelletkessel"
//             },
//             {
//                 "code": "heating_system_planned_8",
//                 "system": "Gas-Brennwert",
//                 "efficiency": 0.8,
//                 "label": "Gas-Brennwert"
//             },
//             {
//                 "code": "heating_system_planned_9",
//                 "system": "Öl-Brennwert",
//                 "efficiency": 0.78,
//                 "label": "Öl-Brennwert"
//             }
//         ]
//     }
// }

    {key: "heizung", label: "Heizung", type: "options", options_key: "heating_system", options_state:"current_state", options: MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT, default: MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT[0].value},
    {key: "heizung_future", label: "geplante Heizung", type: "options", options_key: "heating_system", options_state:"planned_state", options: MASSNAHMEN_HEIZUNG_OPTIONS_NEW, default: MASSNAHMEN_HEIZUNG_OPTIONS_NEW[0].value},
    {key: "heizung_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "heizung_kosten", label: "Kosten", type: "number", step: 500,unit:"€", placeholder:"10000 €", default: undefined},
    {key: "heizung_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},
    {key: "heizung_natural_refrigerant", label: "natürliches Kältemittel<br>+5% Effizienzbonus", type: "boolean", default: undefined},
    {key: "heizung_natural_refrigerant_future", label: "natürliches Kältemittel<br>+5% Effizienzbonus", type: "boolean", default: undefined},
    {key: "heizung_dust_emission", label: "erfüllt Staub-Emissionsgrenzwert (2,5 mg/m³)<br>+2.500 € Emissionsminderungs-Zuschlag", type: "boolean", default: undefined},
    {key: "hot_water", label: "Heißwasser", type: "options", options: HOTWATER_OPTIONS, default: HOTWATER_OPTIONS[0].value},


    {key: "income_gt_4k", label: "jährliches Haushaltseinkommen unter 40.000 €<br>+30% Einkommensbonus", type: "boolean", default: undefined},
    {key: "heizung_wird_ausgetauscht", label: "funktionierenden Altheizung wird ausgebaut<br>+20% Klimageschwindigkeitsbonus", type: "boolean", default: undefined},
    
    {key: "keller", label: "Keller", type: "options", options_key: "floor_insulation", options_state:"current_state", options: MASSNAHMEN_KELLER_OPTIONS_CURRENT, default: MASSNAHMEN_KELLER_OPTIONS_CURRENT[0].value},
    {key: "keller_future", label: "geplanter Keller", type: "options", options_key: "floor_insulation", options_state:"planned_state", options: MASSNAHMEN_KELLER_OPTIONS_NEW, default: MASSNAHMEN_KELLER_OPTIONS_NEW[0].value},
    {key: "keller_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "keller_kosten", label: "Kosten",  type: "number", step: 500,unit:"€", placeholder:"10000 €", default: undefined},
    {key: "keller_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "dach", label: "Dach", type: "options", options_key: "roof_insulation", options_state:"current_state", options: MASSNAHMEN_DACH_OPTIONS_CURRENT,  default: MASSNAHMEN_DACH_OPTIONS_CURRENT[0].value},
    {key: "dach_future", label: "geplantes Dach", type: "options", options_key: "roof_insulation", options_state:"planned_state", options: MASSNAHMEN_DACH_OPTIONS_NEW,  default: MASSNAHMEN_DACH_OPTIONS_NEW[0].value},

    // {key: "dach_future_schraege", label: "geplante Neigungswinkel", type: "options", options: MASSNAHMEN_DACH_OPTIONS_NEW_SPARREN,  default: MASSNAHMEN_DACH_OPTIONS_NEW_SPARREN[0].value},
    // {key: "dach_future_decke", label: "geplantes Oberste Geschoßdecke", type: "options", options: MASSNAHMEN_DACH_OPTIONS_NEW_DECKE,  default: MASSNAHMEN_DACH_OPTIONS_NEW_DECKE[0].value},
    {key: "dach_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "dach_kosten", label: "Kosten",  type: "number", step: 500,unit:"€", placeholder:"10000 €", default: undefined},
    {key: "dach_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "fenster", label: "Fenster", type: "options", options_key: "window", options_state:"current_state", options: MASSNAHMEN_FENSTER_OPTIONS_CURRENT, default: MASSNAHMEN_FENSTER_OPTIONS_CURRENT[0].value},
    {key: "fenster_future", label: "geplante Fenster", type: "options", options_key: "window", options_state:"planned_state", options: MASSNAHMEN_FENSTER_OPTIONS_NEW, default: MASSNAHMEN_FENSTER_OPTIONS_NEW[0].value},
    {key: "fenster_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "fenster_kosten", label: "Kosten",  type: "number", step: 500,unit:"€", placeholder:"10000 €", default: undefined},
    {key: "fenster_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "fassade", label: "Fassade", type: "options", options_key: "facade_insulation", options_state:"current_state", options: MASSNAHMEN_FASSADE_OPTIONS_CURRENT, default: MASSNAHMEN_FASSADE_OPTIONS_CURRENT[0].value},
    {key: "fassade_future", label: "geplante Fassade", type: "options", options_key: "facade_insulation", options_state:"planned_state", options: MASSNAHMEN_FASSADE_OPTIONS_NEW, default: MASSNAHMEN_FASSADE_OPTIONS_NEW[0].value},
    {key: "fassade_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "fassade_kosten", label: "Kosten",  type: "number", step: 500,unit:"€", placeholder:"10000 €", default: undefined},
    {key: "fassade_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "solarthermie", label: "Solarthermie", type: "options", options_key: "solar_thermal", options_state:"current_state", options: MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT, default: MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT[0].value},
    {key: "solarthermie_future", label: "geplante Solarthermie", type: "options", options_key: "solar_thermal", options_state:"planned_state", options: MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW, default: MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW[0].value},
    {key: "solarthermie_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "solarthermie_kosten", label: "Kosten",  type:  "number", step:500, unit:"€", placeholder:"10000 €", default: undefined},
    {key: "solarthermie_kollektorflaeche", label: "Kollektorfläche", placeholder:"30 m²", type: "number", step:0.1 ,unit:"m²", default: undefined},
    {key: "solarthermie_speichergroesse", label: "Speichergröße", placeholder:"30 m²", type:  "number", step:0.1 ,unit:"kwh",  default: undefined},
    {key: "solarthermie_kollektorflaeche_future", label: "Kollektorfläche", type:  "number", step:0.1,unit:"m²", default: undefined},
    {key: "solarthermie_speichergroesse_future", label: "Speichergröße", type:  "number", step:1,unit:"kwh", default: undefined},
    {key: "solarthermie_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "solarthermie_roof_pitch", label: "Neigungswinkel", placeholder:"40°", type: "number", step:5, unit:"°", default: undefined},
    {key: "solarthermie_orientation", label: "Ausrichtung", type: "options", options:ROOF_ORIENTATIONS, default:ROOF_ORIENTATIONS[0].value},
    {key: "solarthermie_roof_pitch_future", label: "Neigungswinkel", placeholder:"40°", type: "number", step:5, unit:"°", default: undefined},
    {key: "solarthermie_orientation_future", label: "Ausrichtung", type: "options", options:ROOF_ORIENTATIONS, default:ROOF_ORIENTATIONS[0].value},
    {key: "solarthermie_natural_refrigerant", label: "Kühlmittel", type: "boolean", default: undefined},

    {key: "photovoltaik", label: "Photovoltaik", type: "options", options_key: "photovoltaics", options_state:"current_state", options: MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT, default: MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT[0].value},
    {key: "photovoltaik_future", label: "geplante Photovoltaik", type: "options", options_key: "photovoltaics", options_state:"planned_state", options: MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW, default: MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW[0].value},
    {key: "photovoltaik_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "photovoltaik_kosten", label: "Kosten", type:  "number", step:500,unit:"€", placeholder:"10000 €", default: undefined},
    {key: "photovoltaik_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},

    {key: "photovoltaik_roof_pitch", label:"Neigungswinkel", type: "number", placeholder:"40°", step:5, unit:"°",  default:undefined},
    {key: "photovoltaik_orientation", label:"Ausrichtung", type: "options", options:ROOF_ORIENTATIONS, default:ROOF_ORIENTATIONS[0].value},
    {key: "photovoltaik_annual_yield_kWh", label:"Ertrag (jährlich)", placeholder:"1000 kWh/a",unit:"kWh/a", type: "number", step:500,  default:undefined},
    {key: "photovoltaik_battery_storage", label:"Batteriespeicher vorhanden", type: "boolean", step:500,  default:undefined},
    {key: "photovoltaik_roof_pitch_future", label:"Neigungswinkel", placeholder:"40°", type: "number", step:5, unit:"°",  default:undefined},
    {key: "photovoltaik_orientation_future", label:"Ausrichtung", type: "options", options:ROOF_ORIENTATIONS, default:ROOF_ORIENTATIONS[0].value},
    {key: "photovoltaik_battery_storage_future", label:"Batteriespeicher hinzufügen", type: "boolean", step:500,  default:undefined},

    {key: "lueftung", label: "Lüftung", type: "options", options_key: "ventilation_system", options_state:"current_state", options: MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT, default: MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT[0].value},
    {key: "lueftung_future", label: "geplante Lüftung", type: "options", options_key: "ventilation_system", options_state:"planned_state", options: MASSNAHMEN_LUEFTUNG_OPTIONS_NEW, default: MASSNAHMEN_LUEFTUNG_OPTIONS_NEW[0].value},
    {key: "lueftung_datum", label: "Einbaujahr", type: "year" , placeholder:"1987" , default: undefined},
    {key: "lueftung_kosten", label: "Kosten",  type: "number", step: 500,unit:"€", placeholder:"10000 €", default: undefined},
    {key: "lueftung_isfp", label: "individueller Sanierungsfahrplan", type: "boolean", default: undefined},


  ];

export const MAIN_PROPERTIES_DEFAULT = MAIN_PROPERTIES.reduce((acc: Partial<Record<MainPropertyKey, MainPropertyValue>>, value : MainPropertiesDeclare)=>{
  acc[value.key] = value.default;
  return acc;
}, {}) as MainProperties;

export const MAIN_PROPERTY_LABELS = MAIN_PROPERTIES.reduce((acc: Partial<Record<MainPropertyKey, string>>, value : MainPropertiesDeclare)=>{
  acc[value.key] = value.label;
  return acc;
}, {});

export const MAIN_PROPERTY_HINTS = MAIN_PROPERTIES.reduce((acc: Partial<Record<MainPropertyKey, string>>, value : MainPropertiesDeclare)=>{
  acc[value.key] = value.hint;
  return acc;
}, {});

export const MAIN_PROPERTY_PLACEHOLDERS = MAIN_PROPERTIES.reduce((acc: Partial<Record<MainPropertyKey, string>>, value : MainPropertiesDeclare)=>{
  acc[value.key] = value.placeholder;
  return acc;
}, {});

export type RoofOrientation = "N" | "S" | "O" | "W" |  "NW" | "NO" | "SW" | "SO";


  export interface MainProperties{
    income_gt_4k?:boolean;
    heizung_wird_ausgetauscht?: boolean;
    gebaeude_typ?: GebaeudeTyp;
    postleitzahl?: string;
    strasse?: string;
    hausnummer?: number;
    vollgeschosse?: number;
    wohneinheiten?: number;
    baujahr? : number;
    baujahr_base? : number;
    wohnflaeche?: number;
    oelverbrauch?: number;
    stromverbrauch? : number;
    gasverbrauch?: number;
    stromverbrauchdiodenheizung?: number;
    holzverbrauch?: number;
    gasverbrauch_m3?: number;
    holzverbrauch_t?: number;
    holzverbrauch_m3?: number;
    stromverbrauchwaermepumpe?: number;
    budget?: number;
    privat: boolean;
    massnamen_empfehlen?: boolean;
    beheizte_segmente?: HeatedSegment;
    darlehen: number; 
    kostensteigerung_energie: number;
    co2_price: number;

    heizung?: string;
    heizung_future?: string;
    heizung_datum?: number;
    heizung_kosten?: number;
    heizung_isfp: boolean;
    heizung_natural_refrigerant: boolean;
    heizung_natural_refrigerant_future: boolean;
    heizung_dust_emission: boolean;
    hot_water: string;

    keller?: string;
    keller_future?: string;
    keller_datum?: number;
    keller_kosten?: number;
    keller_isfp: boolean;

    dach?: string;
    dach_future?: string;

    // dach_future_schraege?: string;
    // dach_future_decke?: string;
    dach_datum?: number;
    dach_kosten?: number;
    dach_isfp: boolean;

    fenster?: string;
    fenster_future?: string;
    fenster_datum?: number;
    fenster_kosten?: number;
    fenster_isfp: boolean;

    fassade?: string;
    fassade_future?: string;
    fassade_datum?: number;
    fassade_kosten?: number;
    fassade_isfp: boolean;

    solarthermie?: string;
    solarthermie_future?: string;
    solarthermie_datum?: number;
    solarthermie_kosten?: number;
    solarthermie_kollektorflaeche: number,
    solarthermie_speichergroesse: number,
    solarthermie_kollektorflaeche_future: number,
    solarthermie_speichergroesse_future: number,
    solarthermie_isfp: boolean;

    photovoltaik?: string;
    photovoltaik_future?: string;
    photovoltaik_datum?: number;
    photovoltaik_kosten?: number;
    photovoltaik_isfp: boolean;

    lueftung?: string;
    lueftung_future?: string;
    lueftung_datum?: number;
    lueftung_kosten?: number;
    lueftung_isfp: boolean;

    solarthermie_roof_pitch?: number;
    solarthermie_orientation?: RoofOrientation;
    solarthermie_roof_pitch_future?: number;
    solarthermie_orientation_future?: RoofOrientation;
    solarthermie_natural_refrigerant?: number;
    photovoltaik_roof_pitch?: number;
    photovoltaik_orientation?: RoofOrientation;
    photovoltaik_annual_yield_kWh?: number;
    photovoltaik_battery_storage?: number;
    photovoltaik_roof_pitch_future?: number;
    photovoltaik_orientation_future?: RoofOrientation;
    photovoltaik_battery_storage_future?: number;
};

export type MainPropertyKey = keyof MainProperties;

                      
export type HeatedSegment = [number, number, number];
export type MainPropertyValue = string | number | boolean | GebaeudeTyp | HeatedSegment | undefined; 